import { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import useScrollNav from "../utils/useScrollNav";

export default function NavBar() {
  const { navRef, isScrolled, isHidden } = useScrollNav();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const toggleButtonRef = useRef(null);

  // Close drawer on Escape
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setDrawerOpen(false);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  // Return focus to toggle when closing
  useEffect(() => {
    if (!isDrawerOpen && toggleButtonRef.current) {
      toggleButtonRef.current.focus();
    }
  }, [isDrawerOpen]);

  return (
    <nav
      ref={navRef}
      className={[
        "site-nav",
        isScrolled ? "nav--scrolled" : "",
        isHidden ? "nav--hidden" : "",
      ].join(" ")}
    >
      <div className="nav-inner">
        {/* Left cluster */}
        <div id="nav-left">
          <img src="/assets/armchair.png" alt="Living Room Inquiries Logo" />
          <div className="logo-text-container">
          <span id="living-top">Living Room</span>
          <span id="living-bottom" >Inquiries</span>
          </div>
        </div>

        {/* Right cluster (desktop links) */}
        <div id="nav-right">
          <NavLink to="/" className="nav-link" onClick={() => setDrawerOpen(false)}>Home</NavLink>
          <NavLink to="/about" className="nav-link" onClick={() => setDrawerOpen(false)}>About</NavLink>
          <NavLink to="/events" className="nav-link" onClick={() => setDrawerOpen(false)}>Events</NavLink>
          <NavLink to="/videos" className="nav-link" onClick={() => setDrawerOpen(false)}>Videos</NavLink>
          <NavLink to="/blog" className="nav-link" onClick={() => setDrawerOpen(false)}>Blog</NavLink>
          <NavLink to="/contact" className="nav-link" onClick={() => setDrawerOpen(false)}>Contact</NavLink>
          <NavLink to="/private-sessions" className="nav-link" onClick={() => setDrawerOpen(false)}>Private Sessions</NavLink>
        </div>

        {/* Hamburger button (mobile only) */}
        <button
          ref={toggleButtonRef}
          className="nav-toggle"
          aria-label={isDrawerOpen ? "Close menu" : "Open menu"}
          aria-expanded={isDrawerOpen}
          aria-controls="nav-drawer"
          onClick={() => setDrawerOpen((o) => !o)}
        >
          {/* CSS-only hamburger (animates to X when expanded) */}
          <span className="hamburger" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>
      </div>

      {/* Overlay */}
      <div
        className={`nav-overlay ${isDrawerOpen ? "is-open" : ""}`}
        onClick={() => setDrawerOpen(false)}
      />

      {/* Drawer */}
      <aside
        id="nav-drawer"
        className={`nav-drawer ${isDrawerOpen ? "is-open" : ""}`}
        aria-modal="true"
        role="dialog"
        aria-label="Site menu"
      >
        <div className="nav-drawer-header">
          <span className="nav-drawer-title">Menu</span>
          <button
            className="nav-close"
            aria-label="Close menu"
            onClick={() => setDrawerOpen(false)}
          >
            {/* CSS-only close icon */}
            <span className="icon-close" aria-hidden="true" />
          </button>
        </div>
        <div className="drawer-links">
          <NavLink to="/" className="nav-link" onClick={() => setDrawerOpen(false)}>Home</NavLink>
          <NavLink to="/about" className="nav-link" onClick={() => setDrawerOpen(false)}>About</NavLink>
          <NavLink to="/events" className="nav-link" onClick={() => setDrawerOpen(false)}>Events</NavLink>
          <NavLink to="/videos" className="nav-link" onClick={() => setDrawerOpen(false)}>Videos</NavLink>
          <NavLink to="/blog" className="nav-link" onClick={() => setDrawerOpen(false)}>Blog</NavLink>
          <NavLink to="/contact" className="nav-link" onClick={() => setDrawerOpen(false)}>Contact</NavLink>
          <NavLink to="/private-sessions" className="nav-link" onClick={() => setDrawerOpen(false)}>Private Sessions</NavLink>
        </div>
      </aside>
    </nav>
  );
}
